import { useWizard } from '../../../context/WizardContext';
import { ExamTypeSelector } from '../../../components/wizard/ExamTypeSelector';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import { useTranslation } from '../../../context/LanguageContext';

export function Step4ExamType() {
  const { state, setExamType } = useWizard();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">{t('wizard.examTypeTitle')}</h2>
        <p className="text-sm text-slate-500 mt-1">{t('wizard.examTypeSubtitle')}</p>
      </div>
      <ExamTypeSelector value={state.selectedExamType} onChange={setExamType} />
      <NavigationButtons />
    </div>
  );
}
